import { Platform } from 'react-native';
import BackgroundService, { BackgroundTaskOptions } from 'react-native-background-actions';

import { newOrdersStore } from '@stores/orders';

const sleep = (time: number) =>
  new Promise(resolve => setTimeout(resolve, time));

const orderListenerTask = async () => {
  newOrdersStore.getState().subscribe();

  while (BackgroundService.isRunning()) {
    await sleep(60000); 
  }
};

const options: BackgroundTaskOptions = {
  taskName: 'Orders',
  taskTitle: 'Receiving Orders',
  taskDesc: 'Listening for new restaurant orders',
  taskIcon: {
    name: 'ic_launcher',
    type: 'mipmap',
  },
  color: '#ff6600',
  // Required for Android 14+ compatibility
  foregroundServiceType: ['dataSync'], 
};

export const startOrderForegroundService = async () => {
  if (Platform.OS === 'web') return;

  const isRunning = await BackgroundService.isRunning();
  if (isRunning) return;

  try {
    await BackgroundService.start(orderListenerTask, options);
  } catch (error) {
    console.error('[ForegroundService] Start Error:', error);
  }
};

export const stopOrderForegroundService = async () => {
  if (Platform.OS === 'web') return;
    await BackgroundService.stop();
};